import { prefersReducedMotion } from '../utils/reducedMotion';

export interface ShellPanelMotionTiming {
  duration: number;
  easing: string;
  reducedMotion: boolean;
}

/**
 * Read the shared shell motion tokens at the moment an interaction starts.
 * This keeps JavaScript-driven panel geometry and delayed portal teardown on
 * one timeline without duplicating duration/easing values in feature code.
 */
export function getShellPanelMotionTiming(kind: 'panel' | 'slide' = 'panel'): ShellPanelMotionTiming {
  const rootStyles = getComputedStyle(document.documentElement);
  const durationToken = rootStyles.getPropertyValue(
    kind === 'slide' ? '--duration-slide' : '--duration-panel',
  ).trim() || rootStyles.getPropertyValue('--duration-slide').trim();
  const parsedDuration = Number.parseFloat(durationToken);
  const duration = durationToken.endsWith('ms')
    ? parsedDuration
    : parsedDuration * 1000;

  return {
    duration: Number.isFinite(duration) ? duration : 420,
    easing: rootStyles.getPropertyValue(
      kind === 'slide' ? '--ease-spring' : '--ease-panel',
    ).trim() || 'cubic-bezier(0.4, 0, 0.2, 1)',
    reducedMotion: prefersReducedMotion(),
  };
}
